import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";
import { filtersClient } from "../../interpreter/clients";

const ClientFilter = ({ setClients, getAllClients }) => {
    const [searchData, setSearchData] = useState({
        full_name: ""
    });

    const handleInputChange = (e) => {
        setSearchData({ ...searchData, [e.target.name]: e.target.value });
    };

    const handleSearch = async () => {
        try {
            const filters = {
                parameterSearch: searchData.full_name.trim() || ""
            };

            let data;

            if (!filters.parameterSearch) {
                data = await getAllClients(); // Si está vacío, traer todos los clientes
            } else {
                data = await filtersClient(filters); // Aplicar filtro
            }

            if (data && Array.isArray(data.clients_content)) {
                setClients(data.clients_content);
            } else {
                setClients([]);
            }
        } catch (error) {
            console.error("❌ Error al obtener clientes:", error);
            setClients([]);
        }
    };

    return (
        <div className="bg-white p-4 shadow-md rounded-lg mb-4 w-full">
            <h3 className="text-lg font-semibold mb-2 text-left">Buscador</h3>

            {/* Contenedor con flex y grid para adaptabilidad */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-4 items-center">
                {/* Input */}
                <input
                    type="text"
                    name="full_name"
                    placeholder="Buscar por nombre..."
                    value={searchData.full_name}
                    onChange={handleInputChange}
                    className="border p-2 rounded h-10 w-full text-sm sl:text-base"
                />
                {/* Botón de Buscar */}
                <button
                    onClick={handleSearch}
                    className="bg-blue-600 text-white rounded hover:bg-blue-500 flex items-center justify-center h-12 w-10 sm:w-max px-4"
                >
                    <FaSearch className="mr-2" />
                </button>
            </div>
        </div>
    );
};

export default ClientFilter;
